const documentReady = (function_) => {
  // see if DOM is already available
  if (document.readyState === `complete` || document.readyState === `interactive`) {
    // call on next available tick
    setTimeout(function_, 1)
  } else {
    document.addEventListener(`DOMContentLoaded`, function_)
  }
}

const waitTillExists = (valueFunction, function_) => {
  const tickTime = 0
  const maxWait = 5000
  let maxTimeout
  let timer = setInterval(() => {
    if (valueFunction()) {
      clearInterval(timer)
      clearInterval(maxTimeout)
      function_()
    }
  }, tickTime)
  maxTimeout = setInterval(() => {
    clearInterval(timer)
  }, maxWait)
}

const isMobile = () => /android|webos|iphone|ipad|mac|macintosh|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent)

const cleanPopup = () => {
  const iframes = document.querySelectorAll(`iframe`)
  for (const iframe of iframes) {
    document.querySelector(`#ghost-portal-root`).style.visibility = `hidden`
    const getPortalPowered = () => iframe.contentDocument.body.querySelector(`.gh-portal-powered`)
    waitTillExists(getPortalPowered, () => {
      getPortalPowered().style = `opacity: 0;`
      getPortalPowered().remove()
       document.querySelector(`#ghost-portal-root`).style.visibility = `visible`
    })
  }
}

const getGhostPortal = () => document.querySelector(`#ghost-portal-root`)
const cleanAllPopups = () => {
  const observer = new MutationObserver(() => cleanPopup())

  waitTillExists(getGhostPortal, () => {
    observer.observe(
      getGhostPortal(),
      { childList: true }
    )
  })
  // const triggerSelector = `[data-portal]`
  // const triggers = document.querySelectorAll(triggerSelector) || []
  // for (const trigger of triggers) {
  //   trigger.addEventListener(`click`, () => cleanPopup())
  // }
}